import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import goodsCategoryApi from '../../api/goodsCategory';
import { message } from 'antd';

// 获取商品分类列表
export const fetchCategoryList = createAsyncThunk(
  'goodsCategoryList/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await goodsCategoryApi.getCategoryList(params);
      return response.data;
    } catch (error) {
      message.error('获取商品分类列表失败');
      return rejectWithValue(error.response.data);
    }
  }
);

const goodsCategoryListSlice = createSlice({
  name: 'goodsCategoryList',
  initialState: {
    categoryList: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryList = action.payload;
      })
      .addCase(fetchCategoryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default goodsCategoryListSlice.reducer; 